import { render, staticRenderFns } from "./LayoutHeaderNotifications.vue?vue&type=template&id=84ca71ae&lang=pug"
import script from "./LayoutHeaderNotifications.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports